<template>
  <Icon
    name="filtration"
    :width="14"
    :height="9"
  >
    <path d="M5.25 9H8.25V7.5H5.25V9ZM0 0V1.5H13.5V0H0ZM2.25 5.25H11.25V3.75H2.25V5.25Z" :fill="fill"/>
  </Icon>
</template>

<script>
import iconMixin from "./iconMixin";

export default {
  name: 'Filtration',
  mixins: [iconMixin]
}
</script>

<style scoped>
svg {
  margin-top: 5px;
  margin-right: 8px;
}
</style>